import { Nav } from "@deere/fuel-react/Nav";
import { Grid, Typography, IconButton  } from "@mui/material";
import { useRouteMatch, useLocation, Route, Switch, useHistory, NavLink } from 'react-router-dom';
import LabelSupplierDetails from '../admin-component/label-supp-testing-component/label-supp-details';
import LabelSupplierSummary from '../admin-component/label-supp-summary-component/label-supplier-summary';
import AsnSupplierDetails from '../admin-component/asn-supp-testing-component/asn-supp-details';
import AsnSupplierSummary from '../admin-component/asn-supp-summary-component/asn-supplier-summary';
import DetailsAcknowledgment from "../admin-component/acknowledgment-component/details-acknowledgment";
import SummaryAcknowledgment from "../admin-component/acknowledgment-component/summary-acknowledgment";
import AllInitiatives from "../admin-component/admin-creation/all-initiatives";
import AddInitiatives from "../admin-component/admin-creation/add-initiatives";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const SideNav = (props) => {
    const history = useHistory()
    const { handleKeyDown, usertype, supplierList, userid, username } = props;
    const location = useLocation();
    const { url } = useRouteMatch();
    const navigationItems = [

        {
            label: "Automated EDI Testing",

            subNav: [
                {
                    label: "Supplier Compliance Summary",
                    to: `${url}/asnSummaryCompliance`,
                    selected: location.pathname === '/ediSelfServicePortal/admin/asnSummaryCompliance' ? true : false,
                    component: NavLink
                },
                {
                    label: "Supplier Testing Details",
                    to: `${url}/asnTestingDetails`,
                    selected: location.pathname === '/ediSelfServicePortal/admin/asnTestingDetails' ? true : false,
                    component: NavLink

                },
            ],
        },
        {
            label: "Label Compliance Testing",

            subNav: [
                {
                    label: "Supplier Compliance Summary",
                    to: `${url}/labelSummaryCompliance`,
                    selected: location.pathname === '/ediSelfServicePortal/admin/labelSummaryCompliance' ? true : false,
                    component: NavLink

                },
                {
                    label: "Supplier Testing Details",
                    to: `${url}/labelTestingDetails`,
                    selected: location.pathname === '/ediSelfServicePortal/admin/labelTestingDetails' ? true : false,
                    component: NavLink

                },
            ],
        },
        {
            label: "Acknowledgment ",

            subNav: [
                {
                    label: "Details",
                    to: `${url}/AcknowledgmentDetails`,
                    selected: location.pathname === '/ediSelfServicePortal/admin/AcknowledgmentDetails' ? true : false,
                    component: NavLink
                },
                {
                    label: "Summary",
                    to: `${url}/AcknowledgmentSummary`,
                    selected: location.pathname === '/ediSelfServicePortal/admin/AcknowledgmentSummary' ? true : false,
                    component: NavLink
                },        
                {
                    label: "Add Initiatives",
                    to: `${url}/Addinitiatives`,
                    selected: location.pathname === '/ediSelfServicePortal/admin/Addinitiatives' ? true : false,
                    component: NavLink
                },
            ],
        },
    ];

    return (
        <>
            <Grid className="grid-example" container spacing={3} >
                {(location.pathname.includes('AcknowledgmentSummary') ||
                    location.pathname.includes('Addinitiatives')) ? (
                    <Grid item size={{xs:12}}>
                        <Typography paddingLeft={5} gutterBottom variant="h2" component="h2">
                            Admin 
                            <IconButton sx = {{color:'green'}} onClick = {()=> history.push('/ediSelfServicePortal/admin')}>
                            <KeyboardArrowDownIcon  />
                            </IconButton>
                           
                        </Typography>
                        {location.pathname.includes('AcknowledgmentSummary') && (
                            <SummaryAcknowledgment
                                usertype={usertype}
                                supplierList={supplierList}
                                userid={userid}
                                handleKeyDown={handleKeyDown}
                            />
                        )}
                        {location.pathname.includes('Addinitiatives') && (
                            <AddInitiatives
                                usertype={usertype}
                                supplierList={supplierList}
                                userid={userid}
                                handleKeyDown={handleKeyDown}
                            />
                        )}
                    </Grid>
                ) : (
                    <Grid item size={{sm:2.4, xs:12}} height={'10%'}>
                        <Typography paddingLeft={5} gutterBottom variant="h2" component="h2">
                            Admin
                        </Typography>
                        <Nav variant="vertical" items={navigationItems} />
                    </Grid>
                )}
                <Grid item size={{sm:9.6, xs:12}} >
                    <Switch>
                        <Route path={`${url}/asnSummaryCompliance`}>
                            <AsnSupplierSummary
                                usertype={usertype}
                                supplierList={supplierList}
                                userid={userid}
                                handleKeyDown={handleKeyDown}
                                username={username}
                            />
                        </Route>
                        <Route path={`${url}/asnTestingDetails`}>
                            <AsnSupplierDetails
                                usertype={usertype}
                                supplierList={supplierList}
                                userid={userid}
                                handleKeyDown={handleKeyDown} />
                        </Route>
                        <Route path={`${url}/LabelSummaryCompliance`}>
                            <LabelSupplierSummary
                                usertype={usertype}
                                supplierList={supplierList}
                                userid={userid}
                                handleKeyDown={handleKeyDown}
                                username={username}
                            />
                        </Route>
                        <Route path={`${url}/LabelTestingDetails`}>
                            <LabelSupplierDetails
                                usertype={usertype}
                                supplierList={supplierList}
                                userid={userid}
                                handleKeyDown={handleKeyDown} />
                        </Route>
                        <Route path={`${url}/AcknowledgmentDetails`}>
                            <DetailsAcknowledgment
                                usertype={usertype}
                                supplierList={supplierList}
                                userid={userid}
                                handleKeyDown={handleKeyDown} />
                        </Route>
                        <Route path={`${url}/Allinitiatives`}>
                            <AllInitiatives
                                usertype={usertype}
                                supplierList={supplierList}
                                userid={userid}
                                handleKeyDown={handleKeyDown} />
                        </Route>
                    </Switch>
                </Grid>
            </Grid>
        </>
    )
}

export default SideNav